class ManagementLogs {
    propertyLogs;
    constructor(crowdfundingPropertyLogs) {
        this.propertyLogs = crowdfundingPropertyLogs;
    }
    get logs() {
        return this.propertyLogs;
    }
    get lastLog() {
        return this.propertyLogs[0];
    }
    hasLogs() {
        return this.propertyLogs.length > 0;
    }
}
export default ManagementLogs;
